import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';

import styles from './_index.module.scss';

const Top2BoxEndSpacer = ({ droppableId, index, minHeight = 140 }) => (
  <Draggable draggableId={`${droppableId}__end-spacer`} index={index} isDragDisabled>
    {(provided) => (
      <div
        aria-hidden="true"
        className={styles['top-2-box-end-spacer']}
        ref={provided.innerRef}
        style={{ minHeight }}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
      />
    )}
  </Draggable>
);

Top2BoxEndSpacer.propTypes = {
  droppableId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  minHeight: PropTypes.number,
};

export default Top2BoxEndSpacer;
